import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from "../../../base/base-component.component";
import { DataParser } from "../../../services/squidex/index";
import { SiteSettingModel } from '../../../services';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ContentsComponent } from '../../../pages/contents/contents.component';

@Component({
  selector: 'menu-header',
  templateUrl: './menu-header.component.html',
  styleUrls: ['./menu-header.component.css']
})
export class MenuHeaderComponent extends BaseComponent implements OnInit {

  siteName: string;

  dataParser: DataParser;
  isDashboard: boolean = false;

  @Input()
  siteSetting: Observable<SiteSettingModel>;

  constructor(
    protected readonly translateService: TranslateService,
    private readonly route: ActivatedRoute) {
    super(translateService);
    this.setTranslateContext('MenuHeaderComponent');
    this.dataParser = new DataParser(null);
  }

  ngOnInit() {
    this.setSiteName();
    if (ContentsComponent.toString() === this.route.component.toString()) {
      this.isDashboard = true;
    } else {
      this.isDashboard = false;
    }
  }

  private setSiteName(): void {
    if (this.siteSetting) {
      this.siteSetting.subscribe(v => {
        this.siteName = this.dataParser.pullData(v, 'name', this.translateService.currentLang);
      });
    } else {
      this.siteName = "Error: site setting not loaded";
    }
  }
}
